"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
const firebase = require('firebase');
const config_1 = require('../config');
const auth_1 = require('./auth');
const database_1 = require('./database');
// This the app's interface to Firebase.
__export(require('./types'));
exports.initialize = () => {
    exports.app = firebase.initializeApp(config_1.default.firebase);
    exports.auth = new auth_1.default();
    exports.auth.initialize();
    exports.database = new database_1.default();
    exports.database.initialize();
};



/** WEBPACK FOOTER **
 ** ./src/api/index.ts
 **/